module.exports = __webpack_public_path__ + "img/プロジェクト参加.c197f611.png";